import {
  BACKEND_CONFIG_LOADED,
  BACKEND_CONFIG_RESET,
  BARCODE_GEN_CONFIG_SET,
  DROPLIST_CONFIG_SET,
  GRN_SYNC_FROM_SI_CONFIG_SET,
  PICKLIST_CONFIG_SET,
} from "../types";
import { readCachedBackendConfig } from "../../utils/backend-config-storage";
import { isAdmin } from "../config";

// Seeded from the last known-good /backend/config response instead of a blind
// `false`, so a reload doesn't disable Picklist/Droplist for the round-trip it
// takes the request to come back. The cache is user-editable, so the CPOS-only
// `isAdmin` gate is re-applied here exactly as the saga applies it — a
// hand-written cache entry must not light up these routes on a POS build.
const cachedConfig = readCachedBackendConfig();
const cachedFlag = (value) => isAdmin && value === true;

const initialState = {
  picklistEnabled: cachedFlag(cachedConfig.picklistEnabled),
  dropListEnabled: cachedFlag(cachedConfig.dropListEnabled),
  barcodeGen: cachedFlag(cachedConfig.barcodeGen),
  grnSyncFromSI: cachedConfig.grnSyncFromSI === true,
  configLoaded: false,
};

const picklistReducer = (state = initialState, action) => {
  switch (action.type) {
    case PICKLIST_CONFIG_SET:
      return { ...state, picklistEnabled: action.data };
    case DROPLIST_CONFIG_SET:
      return { ...state, dropListEnabled: action.data };
    case BARCODE_GEN_CONFIG_SET:
      return { ...state, barcodeGen: action.data };
    case GRN_SYNC_FROM_SI_CONFIG_SET:
      return { ...state, grnSyncFromSI: action.data };
    case BACKEND_CONFIG_LOADED:
      return { ...state, configLoaded: true };
    case BACKEND_CONFIG_RESET:
      return {
        picklistEnabled: false,
        dropListEnabled: false,
        barcodeGen: false,
        grnSyncFromSI: false,
        configLoaded: false,
      };
    default:
      return state;
  }
};

export default picklistReducer;
